import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MemberTpiccvData} from '../models/member-tpiccv-data';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemberTpiccvService {

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<MemberTpiccvData>('sbccv_members_tpiccv', ref => ref
      .orderBy('date', 'asc')).snapshotChanges();
  }

  load () {
    return this.db.collection<MemberTpiccvData>('sbccv_members_tpiccv', ref => ref
      .orderBy('date', 'asc')).get();
  }

  loadByName () {
    return this.db.collection<MemberTpiccvData>('sbccv_members_tpiccv', ref => ref
      .orderBy('member_name', 'asc')
      .orderBy('date', 'asc')).get();
  }

  selectByMemberId (memberId: string) {
    return this.db.collection<MemberTpiccvData>('sbccv_members_tpiccv', ref => ref
      .where("member_id", "==", memberId)
      .orderBy('date', 'asc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return {
            ...data,
            id,
            date: data.date?.toDate() || null
          } as MemberTpiccvData;
        }))
      );
  }

  insert (entity: MemberTpiccvData) {
    return this.db.collection('sbccv_members_tpiccv').add(Object.assign({}, entity));
  }

  update (entity: MemberTpiccvData) {
    return this.db.collection('sbccv_members_tpiccv')
      .doc(entity.id)
      .set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_members_tpiccv').doc(entity_id).delete();
  }

  createEntity (data) {
    const entity = new MemberTpiccvData()
    entity.id = data.id;
    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.date = data.date;
    entity.text = data.text;

    return entity
  }

}


